<template>
  <div>
    <p class="title">Alle resultaten {{ popupContent.title.toLowerCase() }}</p>
    <div class="info">
      <div class="row">
        <div v-if="subCats !== null" class="list">
          <div class="wrapper">
            <li
              @click="
                sortedSubCat = '';
                setSubCat('', pageName);
              "
              class="listItem"
              :class="{ activeList: sortedSubCat === '' }"
            >
              {{ $t("components.alles") }}
            </li>
            <li
              @click="
                sortedSubCat = cat;
                setSubCat(cat, pageName);
              "
              :class="{ activeList: sortedSubCat === cat }"
              class="listItem"
              v-for="cat in subCats"
              :key="cat.id"
            >
              {{ cat }}
            </li>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="first"></div>
        <div class="second">
          <span
            @click="changeSortData('value')"
            v-if="pageName !== 'archetypen' && pageName !== 'onderstromen'"
            class="text"
          >
            <img
              @mouseover="
                showInfo();
                typeIndex();
              "
              @mouseout="hideInfo"
              src="../../assets/Icons/info-dark.svg"
            />
            <p class="name">Index</p>
            <img
              class="arrow"
              v-if="sortBy === 'value' && sortAsc"
              :class="{ transform: sortAsc }"
              src="../../assets/Icons/arrow-black.svg"
            />
            <img
              class="arrow"
              v-if="sortBy === 'value' && !sortAsc"
              src="../../assets/Icons/arrow-black.svg"
            />
          </span>
          <span @click="changeSortData('value')" v-else class="text">
            <img
              @mouseover="
                showInfo();
                typeVerschil();
              "
              @mouseout="hideInfo"
              src="../../assets/Icons/info-dark.svg"
            />
            <p class="name">z-score verschil</p>
            <img
              class="arrow"
              v-if="sortBy === 'value' && sortAsc"
              :class="{ transform: sortAsc }"
              src="../../assets/Icons/arrow-black.svg"
            />
            <img
              class="arrow"
              v-if="sortBy === 'value' && !sortAsc"
              src="../../assets/Icons/arrow-black.svg"
            />
          </span>
          <span
            @click="changeSortData('percentage')"
            v-if="pageName !== 'archetypen' && pageName !== 'onderstromen'"
            class="text"
          >
            <img
              @mouseover="
                showInfo();
                typeAbsoluut();
              "
              @mouseout="hideInfo"
              src="../../assets/Icons/info-dark.svg"
            />
            <p class="name">Absoluut</p>
            <img
              class="arrow"
              v-if="sortBy === 'percentage' && sortAsc"
              :class="{ transform: sortAsc }"
              src="../../assets/Icons/arrow-black.svg"
            />
            <img
              class="arrow"
              v-if="sortBy === 'percentage' && !sortAsc"
              src="../../assets/Icons/arrow-black.svg"
            />
          </span>
          <span @click="changeSortData('percentage')" v-else class="text">
            <img
              @mouseover="
                showInfo();
                typeNormaal();
              "
              @mouseout="hideInfo"
              src="../../assets/Icons/info-dark.svg"
            />
            <p class="name">z-score</p>
            <img
              class="arrow"
              v-if="sortBy === 'percentage' && sortAsc"
              :class="{ transform: sortAsc }"
              src="../../assets/Icons/arrow-black.svg"
            />
            <img
              class="arrow"
              v-if="sortBy === 'percentage' && !sortAsc"
              src="../../assets/Icons/arrow-black.svg"
            />
          </span>
        </div>
      </div>
      <div
        class="row"
        v-for="list in listSorting(listCategories)"
        :key="list.id"
      >
        <div class="titles">
          <p class="body">{{ list.title }}</p>
        </div>
        <div class="values">
          <div class="column">
            <!-- <div v-for="record in returnSubSet(title)" :key="record.id" class="record">
              <p class="body" :class="{'green': record.cssClass === 'positive', 'purple': record.cssClass === 'negative'}">{{record.value}} - check</p>
            </div> -->

            <div class="record">
              <p
                class="body"
                :class="{
                  green: list.cssClass === 'positive',
                  purple: list.cssClass === 'negative',
                }"
              >
                {{ list.value }}
              </p>
            </div>
          </div>
          <div class="column">
            <!-- <div v-for="record in returnSubSet(title)" :key="record.id" class="record">
              <p v-if="pageName !== 'archetypen' && pageName !== 'onderstromen'" class="body" :class="{'green': record.cssClass === 'positive', 'purple': record.cssClass === 'negative'}">{{ parseInt(record.percentage) + '%' }} - check2</p>
              <p v-else class="body" :class="{'green': record.cssClass === 'positive', 'purple': record.cssClass === 'negative'}">{{record.percentage}} - check1</p>
            </div> -->

            <div class="record">
              <p
                v-if="pageName !== 'archetypen' && pageName !== 'onderstromen'"
                class="body"
                :class="{
                  green: list.cssClass === 'positive',
                  purple: list.cssClass === 'negative',
                }"
              >
                {{ parseInt(list.percentage) + "%" }}
              </p>
              <p
                v-else
                class="body"
                :class="{
                  green: list.cssClass === 'positive',
                  purple: list.cssClass === 'negative',
                }"
              >
                {{ list.percentage }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { mapState, mapMutations, mapActions } from "vuex";
// export default {
//   props: {
//     popupContent: Object,
//   },
//   data() {
//     return {
//       sortBy: "value",
//       sortAsc: true,
//       dropdown: false,
//       pageName: this.$route.path.substring(
//         this.$route.path.lastIndexOf("/") + 1
//       ),
//       sortedSubCat: "",
//     };
//   },
//   mounted() {
//     this.setSubCat(this.sortedSubCat, this.pageName);
//   },
//   watch: {
//     $route: function (to, from) {
//       this.closePopup();
//     },
//   },
//   methods: {
//     getJourneySort(pageName, cat) {
//       this.getJourneyResultsSort({ cat, pageName });
//     },
//     getSelectionSort(pageName, cat) {
//       this.getResultsSort({ cat, pageName });
//     },
//     setSubCat(cat, pageName) {
//       this.sortedSubCat = cat;
//       switch (pageName) {
//         case "merken":
//           if (!this.fromDB) {
//             this.getSelectionSort(pageName, this.sortedSubCat);
//           } else {
//             this.getJourneySort(pageName, this.sortedSubCat);
//           }
//           break;

//         case "duurzaamheid":
//           if (!this.fromDB) {
//             this.getSelectionSort(pageName, this.sortedSubCat);
//           } else {
//             this.getJourneySort(pageName, this.sortedSubCat);
//           }
//           break;

//         case "lifestyle":
//           if (!this.fromDB) {
//             this.getSelectionSort(pageName, this.sortedSubCat);
//           } else {
//             this.getJourneySort(pageName, this.sortedSubCat);
//           }
//           break;

//         case "media":
//           if (!this.fromDB) {
//             this.getSelectionSort(pageName, this.sortedSubCat);
//           } else {
//             this.getJourneySort(pageName, this.sortedSubCat);
//           }
//           break;

//         case "overtuigingsstrategieën":
//           if (!this.fromDB) {
//             this.getSelectionSort(pageName, this.sortedSubCat);
//           } else {
//             this.getJourneySort(pageName, this.sortedSubCat);
//           }
//           break;

//         case "politiek":
//           if (!this.fromDB) {
//             this.getSelectionSort(pageName, this.sortedSubCat);
//           } else {
//             this.getJourneySort(pageName, this.sortedSubCat);
//           }
//           break;

//         case "demografie":
//           if (!this.fromDB) {
//             this.getSelectionSort(pageName, this.sortedSubCat);
//           } else {
//             this.getJourneySort(pageName, this.sortedSubCat);
//           }
//           break;
//       }
//       this.dropdown = false;
//     },
//     splitString(position, value) {
//       let full = value.split(" : ");
//       let word = full[position];
//       return word;
//     },
//     // returnSubSet (title) {
//     //   if (!this.fromDB) {
//     //     if (this.resultsPopupTable.resultView === undefined || this.resultsPopupTable.resultTable === undefined) {

//     //     } else {
//     //       return this.resultsPopupTable.resultTable.filter(function (tag) {
//     //         if (tag.title.indexOf(title) !== -1) {
//     //           return tag
//     //         }
//     //       })
//     //     }
//     //   } else {
//     //     if (this.dataTableResults.resultView === undefined || this.dataTableResults.resultTable === undefined) {

//     //     } else {
//     //       return this.dataTableResults.resultTable.filter(function (tag) {
//     //         if (tag.title.indexOf(title) !== -1) {
//     //           return tag
//     //         }
//     //       })
//     //     }
//     //   }
//     // },
//     changeSortData(sortBy) {
//       this.sortBy = sortBy;
//       this.sortAsc = !this.sortAsc;
//     },
//     listSorting(list) {
//       if (this.sortBy === "value") {
//         return list.sort((a, b) => {
//           return this.sortAsc ? a.value - b.value : b.value - a.value;
//         });
//       } else {
//         return list.sort((a, b) => {
//           return this.sortAsc
//             ? parseFloat(a.percentage) - parseFloat(b.percentage)
//             : parseFloat(b.percentage) - parseFloat(a.percentage);
//         });
//       }
//       // return list
//     },
//     ...mapMutations("popupLeft", ["closePopup"]),
//     ...mapMutations("moreInfo", [
//       "showInfo",
//       "hideInfo",
//       "typeVerschil",
//       "typeNormaal",
//       "typeIndex",
//       "typeAbsoluut",
//     ]),
//     ...mapActions("baseRef", ["getResultsSort"]),
//     ...mapActions("journey", ["getJourneyResultsSort"]),
//   },
//   computed: {
//     /* eslint-disable */
//     ...mapState("baseRef", ["resultsPopupTable", "dataTableTopic"]),
//     ...mapState("moreInfo", ["display"]),
//     ...mapState("journey", ["fromDB", "dataTableResults"]),
//     subCats() {
//       if (!this.fromDB) {
//         if (this.resultsPopupTable === undefined) {
//         } else {
//           return this.resultsPopupTable.pageTopics;
//         }
//       } else {
//         if (this.dataTableResults === undefined) {
//         } else {
//           return this.dataTableResults.pageTopics;
//         }
//       }
//     },
//     listCategories() {
//       let uniques = [];
//       if (!this.fromDB) {
//         if (
//           this.resultsPopupTable.resultView === undefined ||
//           this.resultsPopupTable.resultTable === undefined
//         ) {
//         } else {
//           this.resultsPopupTable.resultTable.forEach((element) => {
//             // uniques.push(element.title)
//             uniques.push(element);
//           });
//           return uniques;
//         }
//       } else {
//         if (
//           this.dataTableResults.resultView === undefined ||
//           this.dataTableResults.resultTable === undefined
//         ) {
//         } else {
//           this.dataTableResults.resultTable.forEach((element) => {
//             // uniques.push(element.title)
//             uniques.push(element);
//           });
//           return uniques;
//         }
//       }
//     },
//   },
// };

import { ref, computed, onMounted, watch, defineComponent } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

export default defineComponent({
  props: {
    popupContent: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const route = useRoute();
    const store = useStore();

    const sortBy = ref("value");
    const sortAsc = ref(true);
    const dropdown = ref(false);
    const pageName = route.path.substring(route.path.lastIndexOf("/") + 1);
    const sortedSubCat = ref("");

    const setSubCat = (cat, pageName) => {
      sortedSubCat.value = cat;
      switch (pageName) {
        case "merken":
        case "duurzaamheid":
        case "lifestyle":
        case "media":
        case "overtuigingsstrategieën":
        case "politiek":
        case "demografie":
          if (!store.state.journey.fromDB) {
            store.dispatch("baseRef/getResultsSort", { cat, pageName });
          } else {
            store.dispatch("journey/getJourneyResultsSort", { cat, pageName });
          }
          break;
      }
      dropdown.value = false;
    };

    const splitString = (position, value) => {
      const full = value.split(" : ");
      const word = full[position];
      return word;
    };

    const changeSortData = (newSortBy) => {
      sortBy.value = newSortBy;
      sortAsc.value = !sortAsc.value;
    };

    const listSorting = (list) => {
      if (sortBy.value === "value") {
        return list.sort((a, b) => {
          return sortAsc.value ? a.value - b.value : b.value - a.value;
        });
      } else {
        return list.sort((a, b) => {
          return sortAsc.value
            ? parseFloat(a.percentage) - parseFloat(b.percentage)
            : parseFloat(b.percentage) - parseFloat(a.percentage);
        });
      }
    };

    const handleRouteChange = (to, from) => {
      store.commit("popupLeft/closePopup");
    };

    watch(() => route, handleRouteChange);

    onMounted(() => {
      setSubCat(sortedSubCat.value, pageName);
    });

    const resultsPopupTable = computed(
      () => store.state.baseRef.resultsPopupTable
    );
    const dataTableResults = computed(
      () => store.state.journey.dataTableResults
    );
    const display = computed(() => store.state.moreInfo.display);
    const fromDB = computed(() => store.state.journey.fromDB);

    const subCats = computed(() => {
      if (!fromDB.value) {
        return resultsPopupTable.value?.pageTopics || [];
      } else {
        return dataTableResults.value?.pageTopics || [];
      }
    });

    const listCategories = computed(() => {
      const resultView = !fromDB.value
        ? resultsPopupTable.value?.resultView
        : dataTableResults.value?.resultView;
      const resultTable = !fromDB.value
        ? resultsPopupTable.value?.resultTable
        : dataTableResults.value?.resultTable;

      if (resultView && resultTable) {
        return resultTable.filter((tag) =>
          tag.title.includes(props.popupContent.title)
        );
      }
      return [];
    });

    return {
      sortBy,
      sortAsc,
      dropdown,
      pageName,
      sortedSubCat,
      setSubCat,
      splitString,
      changeSortData,
      listSorting,
      resultsPopupTable,
      dataTableResults,
      display,
      fromDB,
      subCats,
      listCategories,
    };
  },
});
</script>

<style lang="sass" scoped>
.display
  display: flex !important
.transform
  display: flex
  transform: rotate(-90deg) !important
.green
  color: #009987
.purple
  color: #964380
p
  margin: 0
  direction: ltr
.title
  font-size: 28px
  line-height: 38px
  margin-bottom: 20px
  font-family: "Ubuntu Light"
  font-weight: normal
.info
  display: flex
  flex-direction: column
  direction: ltr
  .row
    display: flex
    width: 100%
    margin-bottom: 10px
    align-items: center
    .first
      position: relative
      display: flex
      width: 50%
    .list
      display: flex
      width: 100%
      white-space: nowrap
      position: relative
      margin-top: -5px
      &:after
        content: ''
        position: absolute
        left: 0
        right: 0
        height: 1px
        background-color: #83888c
        bottom: 1px
        width: 100%
      .wrapper
        display: flex
        flex-wrap: wrap
        padding-bottom: 0px
        li
          list-style-type: none
          cursor: pointer
          margin-bottom: 5px
          display: flex
          flex-shrink: 0
          &:after
            content: ''
            position: absolute
            left: 0
            right: 0
            height: 1px
            background-color: rgba($black, 0.5)
            bottom: -4px
            width: 100%
        .listItem
          box-sizing: border-box
          font-size: 13px
          line-height: 17px
          color: rgba($black, 0.5)
          padding-right: 10px
          padding-left: 10px
          position: relative
          margin-top: 5px
          &:hover
            color: $black
      .activeList
        color: $black !important
        margin-bottom: 0px
        border-radius: 1.5px
        font-weight: 500
        &:after
          position: absolute
          content: ''
          width: 100%
          bottom: -5px !important
          left: 0
          right: 0
          background-color: $black !important
          border-radius: 1.5px !important
          height: 3px !important
          z-index: 10 !important
    .second
      display: flex
      justify-content: space-between
      width: 50%
      .text
        display: flex
        justify-content: flex-end
        width: 50%
        font-size: 12px
        line-height: 13px
        align-items: center
        color: #909498
        .name
          &:hover
            cursor: pointer
        .arrow
          margin-right: 0px
          transform: rotate(90deg)
        img
          margin-right: 5px
    .titles
      display: flex
      flex-direction: row
      width: 50%
      .body
        font-size: 13px
        line-height: 14px
    .values
      display: flex
      flex-direction: row
      justify-content: space-between
      width: 50%
      .column
        display: flex
        flex-direction: column
        align-items: flex-end
        width: 50%
        .record
          display: flex
          flex-direction: column
          text-align: right
          margin-bottom: 10px
          &:last-child
            margin-bottom: 0px
          .body
            font-size: 13px
            line-height: 14px
</style>
